(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('click', (event) => {
    const link = event.target.closest('header-drawer .menu-drawer__menu a[href]');
    if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const destination = new URL(link.href, window.location.href);
    if (destination.origin !== window.location.origin || destination.pathname !== window.location.pathname || !destination.hash) return;
    const target = document.getElementById(decodeURIComponent(destination.hash.slice(1)));
    const drawer = link.closest('header-drawer');
    if (!target || typeof drawer.closeMenuDrawer !== 'function') return;
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    drawer.closeMenuDrawer(event, target);
    drawer.querySelector('summary').setAttribute('aria-expanded', 'false');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-application-steps"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mc-application')) {
    customElements.define('mc-application', class extends HTMLElement {
      connectedCallback() {
        this.images = [...this.querySelectorAll('[data-animation]')];
        this.button = this.querySelector('[data-motion-toggle]');
        if (!this.images.length || !this.button) return;
        this.controller = new AbortController();
        this.preference = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = this.preference.matches;
        this.visible = false;
        this.button.hidden = false;
        this.button.addEventListener('click', () => { this.paused = !this.paused; this.update(); }, { signal: this.controller.signal });
        this.preference.addEventListener('change', (event) => { this.paused = event.matches; this.update(); }, { signal: this.controller.signal });
        this.observer = new IntersectionObserver(([entry]) => { this.visible = entry.isIntersecting; this.update(); }, { rootMargin: '120px' });
        this.observer.observe(this);
        this.update();
      }

      update() {
        this.button.querySelector('[data-motion-label]').textContent = this.paused ? this.button.dataset.play : this.button.dataset.pause;
        this.button.querySelector('[data-motion-icon]').textContent = this.paused ? '▷' : 'Ⅱ';
        this.images.forEach((image) => {
          const source = this.paused || !this.visible ? image.dataset.poster : image.dataset.animation;
          if (image.getAttribute('src') !== source) image.setAttribute('src', source);
        });
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mc-faq')) {
    customElements.define('mc-faq', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.addEventListener('shopify:block:select', (event) => {
          const detail = event.target.closest('details');
          if (detail && this.contains(detail)) detail.open = true;
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-sales-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mc-sales-faq')) {
    customElements.define('mc-sales-faq', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.addEventListener('shopify:block:select', (event) => {
          const detail = event.target.closest('details');
          if (detail && this.contains(detail)) detail.open = true;
        }, { signal: this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-sales-proof"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mc-review-carousel')) {
    customElements.define('mc-review-carousel', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.track = this.querySelector('.mc-proof-track');
        this.cards = [...this.track.children].filter(el => el.matches('article'));
        this.controls = this.querySelector('.mc-proof-controls');
        this.prev = this.querySelector('[data-step-prev]');
        this.next = this.querySelector('[data-step-next]');
        this.counter = this.querySelector('[data-step-current]');
        this.controls.hidden = this.cards.length < 2;
        this.update = () => {
          const left = this.track.getBoundingClientRect().left;
          this.index = this.cards.reduce((best, card, i) => Math.abs(card.getBoundingClientRect().left - left) < Math.abs(this.cards[best].getBoundingClientRect().left - left) ? i : best, 0);
          this.pageSize = matchMedia('(max-width: 749px)').matches ? 1 : 2;
          this.counter.textContent = String(Math.floor(this.index / this.pageSize) + 1);
          this.querySelector('[data-step-total]').textContent = String(Math.ceil(this.cards.length / this.pageSize));
          this.prev.disabled = this.index === 0;
          this.next.disabled = this.index >= this.cards.length - this.pageSize;
        };
        this.move = (index, instant = false) => {
          if (!this.cards[index]) return;
          const left = this.cards[index].getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft;
          this.track.scrollTo({ left, behavior: instant || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        this.prev.addEventListener('click', () => this.move(this.index - this.pageSize), options);
        this.next.addEventListener('click', () => this.move(this.index + this.pageSize), options);
        this.track.addEventListener('scroll', this.update, { ...options, passive: true });
        this.addEventListener('shopify:block:select', event => {
          const index = this.cards.findIndex(card => card === event.target || card.contains(event.target));
          this.move(index, true);
        }, options);
        this.resize = new ResizeObserver(this.update);
        this.resize.observe(this.track);
        this.update();
      }
      disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-sales-steps"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mc-steps-carousel')) {
    customElements.define('mc-steps-carousel', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.track = this.querySelector('.mc-sales__steps');
        this.cards = [...this.track.children].filter(el => el.matches('article'));
        this.controls = this.querySelector('.mc-steps-controls');
        this.prev = this.querySelector('[data-step-prev]');
        this.next = this.querySelector('[data-step-next]');
        this.counter = this.querySelector('[data-step-current]');
        this.controls.hidden = this.cards.length < 2;
        this.update = () => {
          const left = this.track.getBoundingClientRect().left;
          this.index = this.cards.reduce((best, card, i) => Math.abs(card.getBoundingClientRect().left - left) < Math.abs(this.cards[best].getBoundingClientRect().left - left) ? i : best, 0);
          this.counter.textContent = String(this.index + 1);
          this.prev.disabled = this.index === 0;
          this.next.disabled = this.index >= this.cards.length - 1;
        };
        this.move = (index, instant = false) => {
          if (!matchMedia('(max-width: 749px)').matches || !this.cards[index]) return;
          const left = this.cards[index].getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft;
          this.track.scrollTo({ left, behavior: instant || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        this.prev.addEventListener('click', () => this.move(this.index - 1), options);
        this.next.addEventListener('click', () => this.move(this.index + 1), options);
        this.track.addEventListener('scroll', this.update, { ...options, passive: true });
        this.addEventListener('shopify:block:select', event => {
          const index = this.cards.findIndex(card => card === event.target || card.contains(event.target));
          this.move(index, true);
        }, options);
        this.resize = new ResizeObserver(this.update);
        this.resize.observe(this.track);
        this.update();
      }
      disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-sales-styles"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mc-range-carousel')) {
    customElements.define('mc-range-carousel', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.track = this.querySelector('.mc-sales__styles');
        this.cards = [...this.track.children].filter(el => el.matches('article'));
        this.controls = this.querySelector('.mc-steps-controls');
        this.prev = this.querySelector('[data-step-prev]');
        this.next = this.querySelector('[data-step-next]');
        this.counter = this.querySelector('[data-step-current]');
        this.controls.hidden = this.cards.length < 2;
        this.update = () => {
          const left = this.track.getBoundingClientRect().left;
          this.index = this.cards.reduce((best, card, i) => Math.abs(card.getBoundingClientRect().left - left) < Math.abs(this.cards[best].getBoundingClientRect().left - left) ? i : best, 0);
          this.counter.textContent = String(this.index + 1);
          this.prev.disabled = this.index === 0;
          this.next.disabled = this.index >= this.cards.length - 1;
        };
        this.move = (index, instant = false) => {
          if (!matchMedia('(max-width: 749px)').matches || !this.cards[index]) return;
          const left = this.cards[index].getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft;
          this.track.scrollTo({ left, behavior: instant || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        this.prev.addEventListener('click', () => this.move(this.index - 1), options);
        this.next.addEventListener('click', () => this.move(this.index + 1), options);
        this.track.addEventListener('scroll', this.update, { ...options, passive: true });
        this.addEventListener('shopify:block:select', event => {
          const index = this.cards.findIndex(card => card === event.target || card.contains(event.target));
          this.move(index, true);
        }, options);
        this.resize = new ResizeObserver(this.update);
        this.resize.observe(this.track);
        this.update();
      }
      disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mc-social-proof"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mc-social-proof')) {
    customElements.define('mc-social-proof', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.mc-proof__track');
        if (!this.track) return;
        this.controls = this.querySelector('.mc-proof__controls');
        this.previous = this.querySelector('[data-direction="-1"]');
        this.next = this.querySelector('[data-direction="1"]');
        this.status = this.querySelector('.mc-proof__status');
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.controls.addEventListener('click', (event) => {
          const button = event.target.closest('[data-direction]');
          if (!button) return;
          const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          this.track.scrollBy({ left: Number(button.dataset.direction) * (this.track.clientWidth + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, options);
        this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
        this.addEventListener('shopify:block:select', (event) => {
          const card = event.target.closest('.mc-proof__card');
          if (card) this.track.scrollBy({ left: card.getBoundingClientRect().left - this.track.getBoundingClientRect().left, behavior: 'instant' });
        }, options);
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.track);
        this.setAttribute('data-enhanced', '');
        this.update();
      }
      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = this.track.clientWidth + gap;
        const position = Math.abs(this.track.scrollLeft);
        const page = Math.round(position / step) + 1;
        const total = Math.round(max / step) + 1;
        this.controls.hidden = max < 2;
        this.previous.disabled = position < 2;
        this.next.disabled = position >= max - 2;
        this.status.textContent = `${this.status.dataset.pageLabel} ${page} / ${total}`;
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
